import { useMemo } from 'react';
import I18n from 'I18n';
import { useValidatePersonalizationPrerequisitesQuery as useValidationQuery } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeValidationRpc.hooks';
import { getErrorType, getValidationErrorMessage } from 'personalization-lib/utils/validation';
import { safeCreateAssetCoordinates } from 'personalization-lib/utils/assetTypes';
import { CREATE_MODES } from 'personalization-lib/constants/variantCreation';
const getDisabledTooltip = ({
  loading,
  error,
  validationMessage
}) => {
  if (loading) {
    return I18n.text('personalizationLib.shared.tooltips.dataLoading');
  }
  if (error) {
    return I18n.text('personalizationLib.shared.tooltips.dataFetchError');
  }
  return validationMessage;
};
const useCanCreateVariant = ({
  mode,
  assetType,
  assetId,
  skip
} = {}) => {
  const assetCoordinates = useMemo(() => safeCreateAssetCoordinates(assetType, assetId), [assetType, assetId]);
  const {
    data,
    loading,
    error
  } = useValidationQuery({
    variables: {
      validateGenAi: mode === CREATE_MODES.WITH_AI,
      assetSources: assetType ? [assetType] : undefined,
      assetCoordinates
    },
    skip
  });
  const validationErrors = useMemo(() => new Set(data === null || data === void 0 ? void 0 : data.validationErrors.map(getErrorType)), [data === null || data === void 0 ? void 0 : data.validationErrors]);
  const validationMessage = useMemo(() => {
    var _data$validationError;
    return getValidationErrorMessage((_data$validationError = data === null || data === void 0 ? void 0 : data.validationErrors) !== null && _data$validationError !== void 0 ? _data$validationError : [], assetType);
  }, [data === null || data === void 0 ? void 0 : data.validationErrors, assetType]);
  const tooltip = useMemo(() => getDisabledTooltip({
    loading,
    error,
    validationMessage
  }), [loading, error, validationMessage]);
  return useMemo(() => ({
    canCreate: !tooltip,
    validationErrors,
    tooltip,
    loading,
    error
  }), [tooltip, loading, error, validationErrors]);
};
export default useCanCreateVariant;